import { message } from "antd";
import axiosInstance from "../../../helpers/axios";
import { responseDataFormate } from "../../../helpers/bycrypt";

interface CreateQuestionParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const createQuestionAPI =
  ({ payload, onSuccess, onError }: CreateQuestionParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.post(
        `/installation-checklist-questions`,
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Create Question error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };

interface UpdateQuestionParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const updateQuestionAPI =
  ({ payload, onSuccess, onError }: UpdateQuestionParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(
        `/installation-checklist-questions`,
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Update Question error:", error);
      onError?.();

      const errorMessage = error?.response?.data?.message;
      message.error(errorMessage);
    }
  };

export interface QuestionsFilterParams {
  page?: number;
  limit?: number;
  search?: string;
}

interface GetQuestionsListParams {
  filters: QuestionsFilterParams;
  onSuccess?: (data: any) => void;
  onError?: () => void;
}

export const getQuestionsListAPI =
  ({ filters, onSuccess, onError }: GetQuestionsListParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.get(
        "/installation-checklist-questions",
        {
          params: filters,
        },
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Get Questions List Error:", error);
      message.error(error?.response?.data?.message);
      onError?.();
    }
  };

interface ReorderQuestionParams {
  payload: any;
  onSuccess: (data: any) => void;
  onError: () => void;
}

export const reorderQuestionAPI =
  ({ payload, onSuccess, onError }: ReorderQuestionParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.put(
        `/installation-checklist-questions/reorder`,
        payload,
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.(result.data);
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Reorder Question error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to reorder questions";
      message.error(errorMessage);
    }
  };

interface DeleteQuestionParams {
  id: string;
  onSuccess: () => void;
  onError: () => void;
}

export const deleteQuestionAPI =
  ({ id, onSuccess, onError }: DeleteQuestionParams) =>
  async (dispatch: any) => {
    try {
      const response = await axiosInstance.delete(
        `/installation-checklist-questions`,
        {
          data: { _id: id },
        },
      );

      let result = responseDataFormate(response.data);

      if (result?.success) {
        message.success(result?.message);
        onSuccess?.();
      } else {
        message.error(result?.message);
        onError?.();
      }
    } catch (error: any) {
      console.error("Delete Question error:", error);
      onError?.();

      const errorMessage =
        error?.response?.data?.message || "Unable to delete Question";
      message.error(errorMessage);
    }
  };
